import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { ApplyResponse } from "../../api/types/apply"

type initialState = {
    response: ApplyResponse | null
}

const applySlice = createSlice({
    name: "apply",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.apply.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default applySlice.reducer




